import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const inputStyle = {
  width: '100%', padding: '12px 14px', borderRadius: 8,
  background: '#0f1117', border: '1px solid #2a2d3e',
  color: '#e2e8f0', fontSize: 14, outline: 'none',
  boxSizing: 'border-box', fontFamily: 'inherit',
};

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success' | 'error'
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setStatus('success');
        setMessage(data.message);
      } else {
        setStatus('error');
        setMessage(data.error || 'Une erreur est survenue');
      }
    } catch {
      setStatus('error');
      setMessage('Erreur de connexion au serveur.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0f1117', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 380, background: '#1a1d2e', border: '1px solid #2a2d3e', borderRadius: 16, padding: 40, boxShadow: '0 20px 60px rgba(0,0,0,0.5)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔑</div>
          <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: '#e2e8f0' }}>Mot de passe oublié</h1>
          <p style={{ margin: '8px 0 0', color: '#64748b', fontSize: 14 }}>
            Saisissez votre email pour recevoir un lien de réinitialisation.
          </p>
        </div>

        {status === 'success' ? (
          <div>
            <div style={{ background: '#10b98120', border: '1px solid #10b98140', borderRadius: 8, padding: '14px 16px', color: '#10b981', fontSize: 14, lineHeight: 1.6, marginBottom: 20 }}>
              {message}
            </div>
            <button
              onClick={() => navigate('/login')}
              style={{ width: '100%', padding: 13, borderRadius: 8, background: '#41B073', border: 'none', color: '#fff', fontWeight: 600, fontSize: 15, cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Retour à la connexion
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 13, color: '#94a3b8', marginBottom: 6, fontWeight: 500 }}>Adresse email</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="vous@exemple.fr"
                style={inputStyle}
                autoFocus
                required
              />
            </div>

            {status === 'error' && (
              <div style={{ background: '#ef444420', border: '1px solid #ef444440', borderRadius: 8, padding: '10px 14px', color: '#ef4444', fontSize: 13, marginBottom: 16 }}>
                {message}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{ width: '100%', padding: 13, borderRadius: 8, background: loading ? '#35956aaa' : '#41B073', border: 'none', color: '#fff', fontWeight: 600, fontSize: 15, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', transition: 'background 0.2s' }}
            >
              {loading ? 'Envoi...' : 'Envoyer le lien'}
            </button>

            <button
              type="button"
              onClick={() => navigate('/login')}
              style={{ width: '100%', marginTop: 10, padding: '11px', borderRadius: 8, background: 'transparent', border: '1px solid #2a2d3e', color: '#64748b', fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Retour à la connexion
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
